import { render, staticRenderFns } from "./WYSIWYGSelector.vue?vue&type=template&id=a7ef37dc&"
import script from "./WYSIWYGSelector.vue?vue&type=script&lang=js&"
export * from "./WYSIWYGSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports